import { render, staticRenderFns } from "./IbDialogFooterFullscreen.vue?vue&type=template&id=74b061a2&scoped=true"
import script from "./IbDialogFooterFullscreen.vue?vue&type=script&lang=js"
export * from "./IbDialogFooterFullscreen.vue?vue&type=script&lang=js"
import style0 from "./IbDialogFooterFullscreen.vue?vue&type=style&index=0&id=74b061a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b061a2",
  null
  
)

export default component.exports